import React from 'react';
import { Box, Text } from '@common-fe/common-fe';

import Modal from '@/components/elements/AutoBlockedModal/Modal';

import { FAQItem } from './hooks/useRenewalFAQData';
import RenewalFAQModalItem from './RenewalFAQModalItem';

interface Props {
  visible: boolean;
  selectedQuestionIndex: number;
  onToggleVision: (value: boolean) => void;
  faqData: FAQItem[];
}

const RenewalFAQModal: React.FC<Props> = ({ visible, selectedQuestionIndex, onToggleVision, faqData }) => {
  return (
    <Modal visible={visible} onSetVisible={() => onToggleVision(false)} data-testid="renewal-faq-modal">
      <Box direction="column">
        <Box direction="row" align="center" justify="center" pad={{ bottom: 'spacing24' }}>
          <Text size="2xl" color="textTitle" weight="bold">
            FAQ
          </Text>
        </Box>
        <Box gap="s">
          {faqData.map((item, index) => (
            <RenewalFAQModalItem
              key={index}
              question={item.question}
              answer={item.answer}
              index={index}
              initialExpanded={index === selectedQuestionIndex}
            />
          ))}
        </Box>
      </Box>
    </Modal>
  );
};

export default RenewalFAQModal;
